import React, { createContext, useContext, useState } from 'react';
import { fetchPostData } from '@/Components/hooks/Api';

const WarrantContext = createContext();

export const WarrantProvider = ({ children }) => {
  const [warentData, setwarentData] = useState([]);
  const [warentFilterData, setwarentFilterData] = useState([]);
  const [warentStatus, setWarentStatus] = useState();

  const get_Warent_Data = (IncidentId) => {
    fetchPostData('Warrant/GetData_Warrant', { IncidentId }).then((res) => {
      setwarentData(res || []);
      setwarentFilterData(res || []);
    });
  };

  const get_Warrent_Count = (WarrantID) => {
    fetchPostData('HomeApi/GetData_WarrantCount', { WarrantID });
  };

  return (
    <WarrantContext.Provider
      value={{
        warentData,
        setwarentData,
        warentFilterData,
        setwarentFilterData,
        warentStatus,
        setWarentStatus,
        get_Warent_Data,
        get_Warrent_Count,
      }}
    >
      {children}
    </WarrantContext.Provider>
  );
};

export const useWarrant = () => {
  const context = useContext(WarrantContext);
  if (!context) throw new Error('useWarrant must be used within WarrantProvider');
  return context;
};

export default WarrantContext;
